// extracted by mini-css-extract-plugin
export var bodyRow = "_ey-d";
export var cardColumns = "_ey-e";
export var ellipsesOverflow = "_ey-2";
export var flatBottomCorners = "_ey-3";
export var flatTopCorners = "_ey-4";
export var headerActionsDropdown = "_ey-f";
export var headerBottomRow = "_ey-c";
export var headerTopRow = "_ey-b";
export var orderDetailsWrapper = "_ey-0";
export var orderInfoContainer = "_ey-1";
export var productDetails = "_ey-9";
export var productImage = "_ey-5";
export var responsiveTable = "_ey-8";
export var shipmentContainer = "_ey-a";
export var tableBottomLeft = "_ey-6";
export var tableBottomRight = "_ey-7";